import React from "react";

import {
    Avatar,
    Badge,
    Button,
    Space,
    Tag,
    Typography
} from "antd";

import {
    CloseOutlined,
    ShopOutlined,
    UserOutlined
} from "@ant-design/icons";

const { Text, Title } = Typography;

const STATUS_COLOR = {
    OPEN: "processing",
    NEGOTIATION: "processing",
    AGREEMENT_PENDING: "warning",
    AGREEMENT_ACCEPTED: "success",
    PAYMENT_PENDING: "gold",
    PAYMENT_COMPLETED: "green",
    DELIVERY_PENDING: "cyan",
    COMPLETED: "success",
    ARCHIVED: "default"
};

const ConversationHeader = ({
                                conversation,
                                loading,
                                onClose,
                                buyerMessages = 0,
                                sellerMessages = 0
                            }) => {

    if (!conversation) {
        return null;
    }

    const inquiry = conversation.inquiry;

    if (!inquiry) {
        return null;
    }

    return (
        <div
            style={{
                background: "#ffffff",
                padding: 20,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
            }}
        >
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 16
                }}
            >
                <Badge
                    dot={buyerMessages > sellerMessages}
                    color="#52c41a"
                >
                    <Avatar
                        size={58}
                        icon={<UserOutlined />}
                    />
                </Badge>

                <div>
                    <Title
                        level={5}
                        style={{ margin: 0 }}
                    >
                        Acheteur
                    </Title>

                    <Space>
                        <ShopOutlined />

                        <Text type="secondary">
                            {inquiry.buyerTenantCode}
                        </Text>
                    </Space>

                    <br />

                    <Text type="secondary">
                        Conversation #{inquiry.inquiryNumber}
                    </Text>

                    <br />

                    <Space wrap>
                        <Tag
                            color={
                                STATUS_COLOR[inquiry.status]
                                || "default"
                            }
                        >
                            {inquiry.status}
                        </Tag>

                        <Tag color="blue">
                            Acheteur {buyerMessages}/3
                        </Tag>

                        <Tag color="green">
                            Vendeur {sellerMessages}/3
                        </Tag>
                    </Space>
                </div>
            </div>

            <Button
                type="text"
                icon={<CloseOutlined />}
                loading={loading}
                onClick={onClose}
            />
        </div>
    );
};

export default ConversationHeader;